export const POPPINS = { fontFamily: "'Poppins', sans-serif" };
export const HEADER_COLOR = "#1B2559";
export const PRIMARY = "#1976d2";
export const CAPTION_COLOR = "#64748B";
